const MS_PER_HOUR = 60 * 60 * 1000;

export class OzDate {
    public static fromDate (date: Date): OzDate {
        return new OzDate(
            Date.UTC(
                date.getUTCFullYear(),
                date.getUTCMonth(),
                date.getUTCDate(),
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
            ),
        );
    }

    private _timestamp: number = 0;
    private _offset: number = 0;

    private _dateCache: Date = new Date(0);

    public constructor (utcTimestamp: number) {
        this._timestamp = utcTimestamp;

        this.updateCache();
    }

    public setOffset (hours: number): void {
        this._offset = hours;

        this.updateCache();
    }

    private updateCache (): void {
        const offsetMs: number = this._offset * MS_PER_HOUR;

        this._dateCache = new Date(this._timestamp + offsetMs);
    }

    public getFullYear (): number {
        return this._dateCache.getUTCFullYear();
    }

    public getMonth (): number {
        return this._dateCache.getUTCMonth();
    }

    public getDate (): number {
        return this._dateCache.getUTCDate();
    }

    public getHours (): number {
        return this._dateCache.getUTCHours();
    }

    public getMinutes (): number {
        return this._dateCache.getUTCMinutes();
    }

    public getSeconds (): number {
        return this._dateCache.getUTCSeconds();
    }

    public toString (): string {
        return `${this.getMonth() + 1}/${this.getDate()}/${this.getFullYear()} ${this.getHours()}:${this.getMinutes()}:${this.getSeconds()}`;
    }
}
